import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { getField } from 'src/common/helper';
import { fontNote, sizeColumn } from '../../styles';

// type DaysCalendarHeaderThirdProps = {
//   dataNote: any;
//   daysCal: any[];
//   handleOpenDialogEditNote: (data: any) => () => void;
// };

const DaysCalendarHeaderThird = (props: any) => {
  const getNote = (day: string, type: string, id: number) => {
    let typeId = 0;

    switch (type) {
      case 'doctor':
        typeId = 1;
        break;
      case 'machine':
        typeId = 3;
        break;
      case 'nurse':
        typeId = 4;
        break;
      case 'reception':
        typeId = 5;
        break;
    }

    return props.dataNote &&
      props.dataNote[day] &&
      props.dataNote[day][typeId] &&
      props.dataNote[day][typeId][id]
      ? props.dataNote[day][typeId][id]
      : {};
  };

  return props.daysCal.map((day: any, indexDay: number) => (
    <React.Fragment key={'note-' + day['day']}>
      {day['doctors'] &&
        day['doctors'].map((doctor: any, indexDoctor: number) => (
          <th
            key={day['day'] + '-note-doctor-' + doctor['id']}
            colSpan={2}
            align='left'
            onClick={props.handleOpenDialogEditNote(
              getNote(day['day'], 'doctor', doctor['id'])
            )}
          >
            <Typography sx={{ ...fontNote }} component='pre'>
              {getField(
                getNote(day['day'], 'doctor', doctor['id']),
                'note',
                ''
              )}
            </Typography>
          </th>
        ))}
      {day['machines'] &&
        day['machines'].map((machine: any, indexMachine: number) => (
          <th
            key={day['day'] + '-note-machines-' + machine['id']}
            rowSpan={2}
            align='left'
            style={{
              ...sizeColumn,
              borderBottom: '1px solid #DDD',
            }}
            onClick={props.handleOpenDialogEditNote(
              getNote(day['day'], 'machine', machine['id'])
            )}
          >
            <Typography sx={{ ...fontNote }} component='pre'>
              {getField(
                getNote(day['day'], 'machine', machine['id']),
                'note',
                ''
              )}
            </Typography>
          </th>
        ))}
      {day['nurse'] &&
        day['nurse'].map((nur: any, index: number) => (
          <th
            key={day['day'] + '-note-nurse-' + nur}
            rowSpan={2}
            align='left'
            style={{
              ...sizeColumn,
              borderBottom: '1px solid #DDD',
            }}
            onClick={props.handleOpenDialogEditNote(
              getNote(day['day'], 'nurse', index)
            )}
          >
            <Typography sx={{ ...fontNote }} component='pre'>
              {getField(getNote(day['day'], 'nurse', index), 'note', '')}
            </Typography>
          </th>
        ))}
      {day['reception'] &&
        day['reception'].map((reception: any, index: number) => (
          <th
            key={day['day'] + '-note-reception-' + reception}
            rowSpan={2}
            align='left'
            style={{
              ...sizeColumn,
              borderBottom: '1px solid #DDD',
            }}
            onClick={props.handleOpenDialogEditNote(
              getNote(day['day'], 'reception', index)
            )}
          >
            <Typography sx={{ ...fontNote }} component='pre'>
              {getField(getNote(day['day'], 'reception', index), 'note', '')}
            </Typography>
          </th>
        ))}
    </React.Fragment>
  ));
};

export default memo(DaysCalendarHeaderThird);
